package com.wintermar.inspection.core.ui.util

data class SelectionModel(
    val id: String = "",
    val value: String = ""
)
